<template>
  <div v-if="value">
    <div
      class="o-form__block o-form__block_dual"
      v-if="
        ['wait-code', 'invalid-code', 'waiting-code', 'checking-code'].includes(
          value.confirmed
        )
      "
    >
      <div class="m-field">
        <div class="m-field__label">Телефон&nbsp;*</div>
        <input
          class="a-input a-input_placeholder"
          type="tel"
          :value="value.phone | masked"
          placeholder="+7 (000) 000-00-00"
          :disabled="true"
        />
      </div>
      <div class="m-field">
        <div class="m-field__label m-field__label_link m-field__label_hint">
          <a @click="doChangeNumber">Изменить номер</a>
        </div>
        <div class="a-button-change">
          <input
            type="text"
            v-model="code"
            placeholder=""
            class="a-input"
            :disabled="
              ['checking-code', 'waiting-code'].includes(value.confirmed)
            "
          />
          <button
            class="a-button-change__item"
            @click="doCheckCode"
            :disabled="
              ['checking-code', 'waiting-code'].includes(value.confirmed)
            "
          ></button>
        </div>
      </div>
    </div>

    <div
      class="o-form__block o-form__block_dual"
      v-if="!value.confirmed || value.confirmed === 'service-unavailable'"
    >
      <div class="m-field">
        <div class="m-field__label">Телефон&nbsp;*</div>
        <input
          class="a-input"
          type="tel"
          :value="value.phone | masked"
          @input="
            (v) =>
              $emit('input', {
                ...this.value,
                phone: normalizeMask(v.target.value),
              })
          "
          placeholder="+7 (000) 000-00-00"
        />
      </div>
      <div class="m-field">
        <div class="m-field__label m-field__label_link m-field__label_hint">
          <a
            @click="show_hint = true"
            @mouseover="show_hint = true"
            @mouseout="show_hint = false"
          >
            Как подтвердить?
          </a>
          <div
            class="m-field__help-hint"
            v-if="show_hint"
            @click="show_hint = false"
          >
            <ol>
              <li>
                На ваш телефон поступит звонок.
                <span>Отвечать на него не нужно!</span>
              </li>
              <li>
                Последние четыре цифры номера входящего вызова являются кодом,
                например, +7&nbsp;(900)&nbsp;555-<span>46-47</span>
              </li>
              <li>Введите эти цифры в поле кода подтверждения. Готово!</li>
            </ol>
          </div>
        </div>
        <button
          class="a-button a-button_additional"
          @click="doRequestCode"
          :disabled="!value.phone"
        >
          Подтвердить
        </button>
      </div>
    </div>

    <div
      class="o-form__block o-form__block_dual"
      v-if="value.confirmed === true"
    >
      <div class="m-field">
        <div class="m-field__label">Телефон&nbsp;*</div>
        <input
          class="a-input a-input_placeholder"
          type="tel"
          :value="value.phone | masked"
          placeholder="+7 (000) 000-00-00"
          :disabled="true"
        />
      </div>
      <div class="a-button a-button_success"><span>Подтвержден</span></div>
    </div>
    <div class="o-form__block o-form__block_dual o-form__block_min-height">
      <div
        :class="{
          't-calc__info': true,
          't-calc__info_time': true,
          visible: ['wait-code', 'invalid-code'].includes(value.confirmed),
        }"
      >
        Повторный вызов через {{ seconds }} сек.
      </div>
      <div
        :class="{
          'm-field__label': true,
          'm-field__label_error': true,
          visible: value.confirmed === 'invalid-code',
        }"
        v-if="value.confirmed === 'invalid-code'"
      >
        {{ value.error || "Введен неправильный код!" }}
      </div>
      <div
        :class="{
          'm-field__label': true,
          'm-field__label_error': true,
          visible: value.confirmed === 'service-unavailable',
        }"
        v-if="value.confirmed === 'service-unavailable'"
      >
        Попробуйте через 10 минут.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OQPhoneInput",
  components: {},
  props: [
    "label",
    "hint",
    "title",
    "placeholder",
    "value",
    "with-confirmation",
    "confirmed",
    "required",
    "confirm-api",
  ],
  data() {
    return {
      code: "",
      seconds: 0,
      show_hint: false,
    };
  },
  filters: {
    masked: function (value) {
      if (!value) return "";
      value = value.toString().substr(1);
      const code = value.substr(0, 3);
      const phone3 = value.substr(3, 3);
      const phone2 = value.substr(6, 2);
      const phone22 = value.substr(8, 2);
      return `+7 (${code}${phone3 ? ") " : ""}${phone3}${
        phone2 ? "-" : ""
      }${phone2}${phone22 ? "-" : ""}${phone22}`;
    },
  },
  methods: {
    normalizeMask(masked_phone) {
      return masked_phone.replaceAll(/\D/g, "").substr(0, 11);
    },
    validPhone() {
      return this.value?.phone?.length === 11;
    },
    doRequestCode() {
      if (this.validPhone()) {
        this.$emit("input", { ...this.value, confirmed: "waiting-code" });
        this.confirmApi.request_code(this.value.phone).then((phone_id) => {
          if (phone_id) {
            this.$emit("input", {
              ...this.value,
              phone_id,
              confirmed: "wait-code",
            });
          } else {
            this.$emit("input", {
              ...this.value,
              phone_id: "",
              phone: undefined,
              confirmed: "service-unavailable",
            });
          }
        });

        this.seconds = 60;
        const tb = () => {
          if (this.seconds > 0) {
            this.seconds -= 1;
            setTimeout(tb, 1000);
          } else {
            if (
              this.seconds === 0 &&
              ["wait-code", "invalid-code"].includes(this.value.confirmed)
            )
              this.doChangeNumber();
          }
        };
        setTimeout(tb, 1000);
      }
    },
    doCheckCode() {
      this.$emit("input", {
        ...this.value,
        confirmed: "checking-code",
        code: this.code,
      });
      this.confirmApi
        .check_code(this.value.phone_id, this.code)
        .then(({ status, error }) => {
          this.code = "";
          this.$emit("input", {
            ...this.value,
            confirmed: status === "ok" ? true : "invalid-code",
            code: "",
            error: error || "",
          });
        });
    },
    doChangeNumber() {
      this.seconds = -1;
      this.code = "";
      this.$emit("input", {
        ...this.value,
        confirmed: false,
        code: "",
      });
    },
  },
};
</script>

<style scoped lang="scss">
.m-field__label_error,
.t-calc__info_time {
  opacity: 0;
  &.visible {
    opacity: 1;
  }
}
</style>
